import { fragmentsDeliveryAPIStationConfigClientGetConfig } from '@mi-front/api-clients';
import { Station } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import get from 'lodash/get';

export function useIsExternalExportEnabled(station: Station) {
  const query = useQuery({
    queryKey: ['isExternalExportEnabled', station.id],
    queryFn: async () => {
      const result = await fragmentsDeliveryAPIStationConfigClientGetConfig(station.id);

      return !!result.enabled;
    },
  });

  return query.data;
}
